// frontend/src/config/api/endpoints/saudeEndpoints.ts
/**
 * Pensado por: Alcélio Gomes
 * Codificado em coautoria: Claude Code
 * 🚀 NeuroAgentes
 * 
 * AUDITORIA: Endpoints do módulo Saúde.
 */

export const saudeEndpoints = {
  pacientes: '/api/saude/pacientes',
  pacienteById: (id: string) => `/api/saude/pacientes/${id}`,
  pacienteEstatisticas: '/api/saude/pacientes/estatisticas',
  ativarPaciente: (id: string) => `/api/saude/pacientes/${id}/ativar`,
  desativarPaciente: (id: string) => `/api/saude/pacientes/${id}/desativar`,
  avaliacoes: '/api/saude/avaliacoes',
  avaliacaoById: (id: string) => `/api/saude/avaliacoes/${id}`,
  avaliacoesPaciente: (pacienteId: string) => `/api/saude/avaliacoes/paciente/${pacienteId}`,
  avaliacaoAmplitude: (avaliacaoId: string) => `/api/saude/avaliacoes/${avaliacaoId}/amplitude`,
  evolucoes: '/api/saude/evolucao',
  evolucaoById: (id: string) => `/api/saude/evolucao/${id}`,
  evolucoesAvaliacao: (avaliacaoId: string) => `/api/saude/evolucao/avaliacao/${avaliacaoId}`,
  testes: '/api/saude/testes',
  testeById: (id: string) => `/api/saude/testes/${id}`,
  testeAvaliacao: (avaliacaoId: string) => `/api/saude/testes/avaliacao/${avaliacaoId}`,
  exames: '/api/saude/exame',
  exameById: (id: string) => `/api/saude/exame/${id}`,
  exameAvaliacao: (avaliacaoId: string) => `/api/saude/exame/avaliacao/${avaliacaoId}`,
  planos: '/api/saude/plano',
  planoById: (id: string) => `/api/saude/plano/${id}`,
  planoAvaliacao: (avaliacaoId: string) => `/api/saude/plano/avaliacao/${avaliacaoId}`,
  amplitudes: '/api/saude/amplitudes',
  forcaMuscular: '/api/saude/forca-muscular',
  coordenacaoMotora: '/api/saude/coordenacao-motora',
  sensibilidade: '/api/saude/sensibilidade',
  perimetria: '/api/saude/perimetria',
  estiloVida: '/api/saude/estilo-vida',
  questionarioUrologico: '/api/saude/questionario-urologico',
  diagnosticoFuncional: '/api/saude/diagnostico-funcional',
  objetivos: '/api/saude/objetivos',
  consideracoesFinais: '/api/saude/consideracoes-finais',
  anexos: '/api/saude/anexos',
};
